import { render } from "./YourPosts.vue?vue&type=template&id=c0589fbe"
import script from "./YourPosts.vue?vue&type=script&lang=js"
export * from "./YourPosts.vue?vue&type=script&lang=js"

import "./YourPosts.vue?vue&type=style&index=0&id=c0589fbe&lang=css"

import exportComponent from "C:\\Users\\abscu\\OneDrive\\Desktop\\htmlcss\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__